import React from 'react'

export default function RequirementCard({ icon, title, firstListLeftSideText, firstListRightSideText, secListLeftSideText, secListRightSideText, thirdListLeftSideText, thirdListRightSideText }) {
    return (
        <div className='requirementCard relative w-full min-h-[218px] md:min-h-[247px] flex flex-col gap-9 rounded-[18px] border border-primaryWhite/[0.06] p-4 md:p-5 pb-6 md:pb-10 bg-[#1A1A1A] overflow-hidden h-full group duration-500"'>
            <div className='flex items-center gap-4'>
                <div className='flex items-center justify-end px-1 py-3 w-11 h-11 md:w-[57px] md:h-[57px] rounded-xl bg-[#121212] *:h-full'>
                    {icon}
                </div>
                <h4 className='text-base md:text-xxl font-medium leading-5 laptop:leading-6 text-textcolor'>{title}</h4>
            </div>
            <ul className='flex flex-col gap-6'>
                <li className='flex items-center justify-between lg:gap-5 text-xsm md:text-sm font-medium leading-4 text-textcolor text-right'><span className='opacity-50 text-left'>{firstListLeftSideText}</span>{firstListRightSideText}</li>
                <li className='flex items-center justify-between lg:gap-5 text-xsm md:text-sm font-medium leading-4 text-textcolor text-right'><span className='opacity-50 text-left'>{secListLeftSideText}</span>{secListRightSideText}</li>
                <li className='flex items-center justify-between lg:gap-5 text-xsm md:text-sm font-medium leading-4 text-textcolor text-right'><span className='opacity-50 text-left'>{thirdListLeftSideText}</span>{thirdListRightSideText}</li>
            </ul>
        </div>
    )
}
